import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from 'react-router-dom';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

//Redux
import { useDispatch, useSelector } from "react-redux";
import allActions from "../../../actions";

import { headerSearch, toogleButton, unoTheme } from "../../../assets/styles/unoTheme";

import MyInfo from "../../utils/MyInfo";

import UnoButton from "../../utils/UnoButton";
import {
    applyMaskAmount, applyMaskAmountComdinheiro,
    formatMillionNumber, getDayMonthYearByPtDate, getFirstBeforeBusinessDay,
    getLastsMonthsInArray,
    getMonthAgo,
    getShortMonthName,
    getTheLastDayCompleteMonthPt, isMonthAbleToQuotas
} from "../../utils/utils";

//Charts
import { Bar } from 'react-chartjs-2';

import MySelect from '../../utils/MySelect';

import { getBladeComdinheiroByDate } from '../../../controllers/ComdinheiroController';


import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ImportContactsIcon from '@material-ui/icons/ImportContacts';
import ReportProblemIcon from '@material-ui/icons/ReportProblem';
import PrintIcon from '@material-ui/icons/Print';

import moment from 'moment';
import { checkUserIsRole, roles } from '../../utils/user';
import ChartDataLabels from 'chartjs-plugin-datalabels';

const optionsCompareChart = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
        display: true,
        position: 'bottom',
        fullWidth: true,
        labels: {
            filter: function (legendItem, data) {
                return legendItem.text !== 'spacer';
            }
        }
    },

    tooltips: {
        callbacks: {
            label: function (tooltipItem, data) {
                const datasetLabel = data.datasets[tooltipItem.datasetIndex].label;
                if (datasetLabel === 'spacer') return null;
                return applyMaskAmount(tooltipItem.yLabel) + "%";
            }
        }
    },

    scales: {
        yAxes: [{
            ticks: {
                // beginAtZero: true,
                callback: function (value, index, values) {
                    return value + "%";
                }
            },
            afterDataLimits: (axis) => {
                const range = axis.max - axis.min;
                const pad = Math.max(range * 0.02, 4);
                axis.max = axis.max + pad;
            },
        }],
    },
    plugins: {
        datalabels: {
            anchor: 'end',
            align: 'end',
            rotation: -45,
            offset: 4,
            clamp: true,
            clip: true,
            formatter: (value) => `${applyMaskAmount(value)}%`,
            color: '#4A4A4A'
        }
    }

}

const optionsChartPatrimonio = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
        display: true,
        position: 'bottom',
        fullWidth: true,
    },
    scales: {
        yAxes: [{
            ticks: {
                // beginAtZero: true,
                callback: function (value) {
                    return formatMillionNumber(value);
                }
            },
            afterDataLimits: (axis) => {
                const range = axis.max - axis.min;
                const pad = Math.max(range * 0.06, 50);
                axis.max = axis.max + pad;
            },
        }],
    },
    tooltips: {
        callbacks: {
            label: function (tooltipItem, data) {
                const ds = data.datasets[tooltipItem.datasetIndex];
                const raw = ds.rawValues?.[tooltipItem.index];
                const value = (raw != null) ? raw : tooltipItem.yLabel * 1_000_000;

                return applyMaskAmount(value, true);
            }
        }
    },
    plugins: {
        datalabels: {
            rotation: -45,
            anchor: 'end',
            align: 'end',
            offset: 0,
            formatter: (value) => {
                if (value >= 1000) {
                    return `${(value / 1000).toFixed(2).replace('.', ',')} bi`;
                }
                return `${value.toFixed(1).replace('.', ',')} mi`;
            },

            font: (context) => {
                // número de barras = número de meses
                const months = context.chart.data.labels.length;

                if (months <= 12) {
                    return { size: 11 };
                }

                if (months <= 24) {
                    return { size: 10 };
                }

                // 36 meses
                return { size: 9 };
            },
            color: '#4A4A4A'
        }
    }

}

const useStyles = makeStyles((theme) => ({
    root: {
        textAlign: 'left',
        display: 'flex',
        flexDirection: 'column',
        height: `calc(100vh - ${unoTheme.topToolbarSize})`,
        overflowY: 'scroll',
        paddingBottom: theme.spacing(3),
    },

    main: {
        width: 'calc(100% - 24px)',
    },

    generalInformations: {
        //padding: theme.spacing(3),
        //margin: '-24px',
        '& .mainInfos': {
            '& .myInfo': {
                '& .MuiTypography-root': {
                    fontSize: '13px',
                }

            }
        },

        '& .myInfo': {
            padding: '6px 0px',
            borderBottom: 'solid 1px #E4E7EB'
        },

        '& .myInfo:last-child': {
            padding: '6px 0px',
            borderBottom: 'none'
        },

    },

    gridPaper: {
        height: '100%',
        borderRadius: '10px',
        padding: theme.spacing(3),

        '& .title': {
            color: '#768191',
        },
    },

    gridPaperTable: {
        borderRadius: '10px',
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3),

        '& .title': {
            color: '#768191',
        },

        '& .MuiTypography-root': {
            paddingLeft: theme.spacing(2),
            paddingBottom: theme.spacing(1),
        }
    },

    headerSearch: headerSearch,

    labelHeader: {
        fontSize: '16px',
        color: unoTheme.defaultTextColor,
        fontWeight: 600,
    },
    switchs: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around',
    },
    progressInput: {
        width: '20px !important',
        height: '20px !important',
    },
    selectable: {
        '& input': {

            cursor: 'pointer',
            color: unoTheme.mainColor,
        }
    },
    toogleButton: toogleButton,

    divChart: {
        width: '100%',
        maxWidth: '100%',
        height: '100%',
        justifyContent: 'center',
        '& .chartHeader': {
            minHeight: '56px',
            height: '56px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
            paddingBottom: '12px',
            paddingRight: '13px',

            '& .MuiTypography-root': {
                marginRight: theme.spacing(1),
            },

            '& .right': {
                display: 'flex',
                alignItems: 'center',
            }
        },

        '& .chartWrapper': {
            height: '500px',
            width: '100%',
        }
    },

    tableBlade: {

        tableLayout: 'fixed',


        '& .MuiTableRow-head': {
            '& .MuiTableCell-root': {
                fontSize: '12px',
                padding: '4px 4px',
                fontWeight: "bold",
                color: '#1C2228',
                wordWrap: 'break-word',
            },

            '& .MuiTableCell-root:first-child': {
                paddingLeft: '16px',
                borderRight: 'solid 1.5px #E4E7EB'
            },
            '& > *': {
                borderBottom: 'unset',
            },
        },

        '& .MuiTableBody-root': {

            '& .MuiTableRow-root': {
                borderRadius: '10px',
                '&:nth-of-type(odd)': {
                    backgroundColor: unoTheme.secondaryTuplaTable,
                    //backgroundColor: 'red',
                },

                '&:nth-of-type(even)': {
                    backgroundColor: unoTheme.mainColor,
                    color: 'white',

                    '& .MuiTableCell-root': {
                        color: 'white',
                    },
                    //backgroundColor: 'red',
                },

                '& > *': {
                    borderBottom: 'unset',
                },
            },

            '& .MuiTableCell-root': {
                fontSize: '12px',
                padding: '12px 4px',
                color: '#768191',
            },

            '& .MuiTableCell-root:first-child': {
                borderRight: 'solid 1.5px #E4E7EB',
                paddingLeft: '16px',
                borderTopLeftRadius: '10px',
                borderBottomLeftRadius: '10px',
            },

            '& .MuiTableCell-root:last-child': {
                borderTopRightRadius: '10px',
                borderBottomRightRadius: '10px',
            },
        },


    }


}));

export default function BladeFundScreen() {

    const classes = useStyles();
    const dispatch = useDispatch();

    const location = useLocation();
    const history = useHistory();

    const currentUser = useSelector(state => state.currentUser)

    const [fundScreen, setFundScreen] = useState(undefined);

    const [referenceDate, setReferenceDate] = useState(null);
    const [periods, setPeriods] = useState(['12 meses', '24 meses', '36 meses']);

    const [dataRetornosChart, setDataRetornosChart] = useState(null);
    const [dataPureRetornosChart, setPureDataRetornosChart] = useState(null);
    const [periodChartSelected, setPeriodChartSelected] = useState(null);

    const [dataPatrimonioChart, setDataPatrimonioChart] = useState(null);
    const [dataPurePatrimonioChart, setPureDataPatrimonioChart] = useState(null);
    const [periodChartPatrimonioSelected, setPeriodChartPatrimonioSelected] = useState(null);

    const [typesChart, setTypesChart] = useState(['Valores acumulados', 'Valores mensais']);
    const [typeChartSelected, setTypeChartSelected] = useState(null);

    const handleChangeTypeChartPeriod = (value) => {
        setTypeChartSelected(value);
        formatDataToRetornosChart(fundScreen['comdinheiro'].returnTable, fundScreen.last12LabelsMonths, value);
    };

    const handleChangeChartPatrimonioPeriod = (value) => {

        setPeriodChartPatrimonioSelected(value);
        formatDataToPatrimonioChart(fundScreen.comdinheiro.patrimonio36.byMonth, parseInt(value), fundScreen.cnpj);

    };

    function getDataRetornosChart(d1, d2, labelMonths) {

        let dataChartInflationRates = {
            labels: labelMonths,
            datasets: [
                {
                    label: 'Fundo',
                    backgroundColor: unoTheme.chartColors[1],
                    data: d1,
                },
                {
                    label: 'spacer',
                    backgroundColor: 'rgba(0,0,0,0)',
                    data: d1.map(() => 0),
                    datalabels: { display: false },
                },
                {
                    label: 'Bechmark',
                    backgroundColor: unoTheme.chartColors[0],
                    data: d2,
                },


            ]
        };

        return dataChartInflationRates;
    }

    function formatDataToRetornosChart(data, labelMonths, type) {

        //Inicializando select de chart year        
        let dataChartFund = [];
        let dataChartBenchmark = [];
        console.log('DATA RETURN TABLE: ', data);

        if (type == 0) {
            //Valores acumulados

            let acumValueFund = 1;
            let acumValueBenchmark = 1;
            for (let m = 0; m < labelMonths.length; m++) {

                let key = labelMonths[m];

                if (m == 11) {
                    key = "Mes_atual"
                }

                acumValueFund *= data['fund'][key] ? (1 + (data['fund'][key] / 100)) : 1;
                acumValueBenchmark *= data['benchmark'][key] ? (1 + (data['benchmark'][key] / 100)) : 1;

                // dataChartFund.push({
                //     y: parseFloat(parseFloat((acumValueFund - 1) * 100).toFixed(2)),
                //     id: 'm-fund-' + key
                // })
                dataChartFund.push(parseFloat(((acumValueFund - 1) * 100).toFixed(2)))

                dataChartBenchmark.push(parseFloat(parseFloat((acumValueBenchmark - 1) * 100).toFixed(2)))

            }



        } else {
            //Valores mensais
            for (let m = 0; m < labelMonths.length; m++) {

                let key = labelMonths[m];

                if (m == 11) {
                    key = "Mes_atual"
                }

                // dataChartFund.push({
                //     y: data['fund'][key],
                //     id: 'm-fund-' + key
                // })

                dataChartFund.push(data['fund'][key] ?? 0)
                dataChartBenchmark.push(data['benchmark'][key])
            }

        }



        const d = getDataRetornosChart(dataChartFund,
            dataChartBenchmark, labelMonths);

        setPureDataRetornosChart(JSON.parse(JSON.stringify(d)));
        setDataRetornosChart(d);

    }

    function getDataPatrimonioChart(valuesMillions, valuesRaw, labels) {

        let dataChartPatrimonio = {
            labels: labels,
            datasets: [
                {
                    label: 'Fundo',
                    backgroundColor: unoTheme.chartColors[1],
                    data: valuesMillions,
                    rawValues: valuesRaw,
                    categoryPercentage: 0.55,
                    barPercentage: 0.75,
                },
            ]
        };

        return dataChartPatrimonio;
    }

    function formatDataToPatrimonioChart(data, period, cnpj) {

        console.log("DATA PATRIMONIO: ", data);
        let valuesMillions = [];
        let valuesRaw = [];


        //Inicializando select de chart year        
        let labels = [];

        //O período pode ser 0, 1 ou 2 corresponde ao valor do select por isso deve ser acrescido de 1
        let resultPeriod = ((period + 1) * 12);
        let dataSlice = data.slice(36 - resultPeriod, 37)

        //Fazendo o slice com o período 12, 24, 36
        dataSlice.forEach(value => {
            valuesRaw.push(value[cnpj]);
            valuesMillions.push(Number((value[cnpj] / 1_000_000).toFixed(1)));
            labels.push(value.data);
        });


        const d = getDataPatrimonioChart(valuesMillions, valuesRaw, labels);

        setPureDataPatrimonioChart(JSON.parse(JSON.stringify(d)))
        setDataPatrimonioChart(d);
    }

    async function loadInfos(fund, dispatch) {

        let prevReferenceDate = getFirstBeforeBusinessDay(getTheLastDayCompleteMonthPt());

        const splittedreferenceDate = prevReferenceDate.split('/');
        const m = parseInt(splittedreferenceDate[1]);
        const y = parseInt(splittedreferenceDate[2]);
        if (!isMonthAbleToQuotas(m, parseInt(y))) {
            if (m == 1) {
                prevReferenceDate = moment(new Date(y - 1, 12, 0)).format('DD/MM/YYYY');
            } else {
                prevReferenceDate = moment(new Date(y, m - 1, 0)).format('DD/MM/YYYY');
            }
        }

        //prevReferenceDate = moment.utc(prevReferenceDate, 'DD/MM/YYYY').subtract(1, 'months').format('DD/MM/YYYY');
        setReferenceDate(prevReferenceDate);

        const response = await getBladeComdinheiroByDate(prevReferenceDate, fund, dispatch);

        if (response.success) {


            fund = {
                ...fund,
                ...response.body
            }

            //obtendo labels dos últimos 12 meses
            fund.last12LabelsMonths = getLastsMonthsInArray(
                prevReferenceDate, 12);

            if (fund.comdinheiro && fund.comdinheiro.patrimonio36) {

                formatDataToPatrimonioChart(fund.comdinheiro.patrimonio36.byMonth, 0, fund.cnpj);
                formatDataToRetornosChart(fund.comdinheiro.returnTable, fund.last12LabelsMonths, 0)

                //normalizando label do mês atual
                const { month, year } = getDayMonthYearByPtDate(prevReferenceDate);
                const currentMonthLabel = `${getShortMonthName(month)}/${year.toString().substring(2)}`
                fund.comdinheiro.returnTable['fund'][currentMonthLabel] = fund.comdinheiro.returnTable['fund']['Mes_atual'];
                fund.comdinheiro.returnTable['benchmark'][currentMonthLabel] = fund.comdinheiro.returnTable['benchmark']['Mes_atual'];
                setFundScreen(fund);
            }

        } else {

            dispatch(allActions.mainAlertActions.setMainAlert({
                message: "Falha ao obter informações da lâmina",
                type: "error",
                show: true
            }));

            history.goBack();

        }

        dispatch(allActions.innerLoadActions.setInnerLoad({
            show: false,
        }));

    }

    function showRegulamento(link) {
        window.open(link)
    }

    const doReport = () => {

        //Normalizando informações para relatório
        console.log("fundScreen: ", fundScreen);
        const data = JSON.parse(JSON.stringify(fundScreen));
        Object.entries(data['comdinheiro'].returnTable.fund).map(([key, value]) => {
            if (key != "Nome_fundo") {
                data['comdinheiro'].returnTable.fund[key] = applyMaskAmountComdinheiro(value);
            }
        })

        if (!data.comdinheiro['realBenchmark']) {
            data.comdinheiro['realBenchmark'] = "-"
        }
        Object.entries(data['comdinheiro'].returnTable.benchmark).map(([key, value]) => {
            if (key != "Nome_fundo") {
                data['comdinheiro'].returnTable.benchmark[key] = applyMaskAmountComdinheiro(value);
            }
        })

        data['comdinheiro'].riscoRetorno.cota.fund = applyMaskAmountComdinheiro(data['comdinheiro'].riscoRetorno.cota.fund);
        data['comdinheiro'].riscoRetorno.pl.fund = applyMaskAmountComdinheiro(data['comdinheiro'].riscoRetorno.pl.fund);
        data['comdinheiro'].riscoRetorno.volatilidade.fund = applyMaskAmountComdinheiro(data['comdinheiro'].riscoRetorno.volatilidade.fund);
        data['comdinheiro'].riscoRetorno.perda_maxima.fund = applyMaskAmountComdinheiro(data['comdinheiro'].riscoRetorno.perda_maxima.fund);
        data['comdinheiro'].riscoRetorno.var.fund = applyMaskAmountComdinheiro(data['comdinheiro'].riscoRetorno.var.fund);
        data['comdinheiro'].riscoRetorno.indice_sharpe.fund = applyMaskAmountComdinheiro(data['comdinheiro'].riscoRetorno.indice_sharpe.fund);
        data['comdinheiro'].riscoRetorno.retorno_maximo.fund = applyMaskAmountComdinheiro(data['comdinheiro'].riscoRetorno.retorno_maximo.fund);
        data['comdinheiro'].riscoRetorno.retorno_minimo.fund = applyMaskAmountComdinheiro(data['comdinheiro'].riscoRetorno.retorno_minimo.fund);
        data['comdinheiro'].riscoRetorno.retorno_medio.fund = applyMaskAmountComdinheiro(data['comdinheiro'].riscoRetorno.retorno_medio.fund);

        data['comdinheiro'].riscoRetorno.cota.benchmark = applyMaskAmountComdinheiro(data['comdinheiro'].riscoRetorno.cota.benchmark);
        data['comdinheiro'].riscoRetorno.pl.benchmark = applyMaskAmountComdinheiro(data['comdinheiro'].riscoRetorno.pl.benchmark);
        data['comdinheiro'].riscoRetorno.volatilidade.benchmark = applyMaskAmountComdinheiro(data['comdinheiro'].riscoRetorno.volatilidade.benchmark);
        data['comdinheiro'].riscoRetorno.perda_maxima.benchmark = applyMaskAmountComdinheiro(data['comdinheiro'].riscoRetorno.perda_maxima.benchmark);
        data['comdinheiro'].riscoRetorno.var.benchmark = applyMaskAmountComdinheiro(data['comdinheiro'].riscoRetorno.var.benchmark);
        data['comdinheiro'].riscoRetorno.indice_sharpe.benchmark = applyMaskAmountComdinheiro(data['comdinheiro'].riscoRetorno.indice_sharpe.benchmark);
        data['comdinheiro'].riscoRetorno.retorno_maximo.benchmark = applyMaskAmountComdinheiro(data['comdinheiro'].riscoRetorno.retorno_maximo.benchmark);
        data['comdinheiro'].riscoRetorno.retorno_minimo.benchmark = applyMaskAmountComdinheiro(data['comdinheiro'].riscoRetorno.retorno_minimo.benchmark);
        data['comdinheiro'].riscoRetorno.retorno_medio.benchmark = applyMaskAmountComdinheiro(data['comdinheiro'].riscoRetorno.retorno_medio.benchmark);

        console.log("Data: ", data);
        dispatch(allActions.reportLoadActions.setReportLoad({
            show: true,
            reportType: "bladeFund",
            referenceDate: referenceDate,
            data: data,
            dataReturnsChart: {
                data: dataPureRetornosChart,
            },
            dataPlChart: {
                data: dataPurePatrimonioChart,
            },
            message: 'Gerando lâmina do Fundo...'
        }))
    }

    useEffect(() => {

        dispatch(allActions.innerLoadActions.setInnerLoad({
            show: true,
            loadMessage: 'Carregando informações...',
        }));


        if (location && location.state) {

            console.log("FUND ALL: ", location.state);
            const fund = {

                ...location.state.fund,
                fundId: location.state.fund.id ?? location.state.fund.fundId,

                //tabela de retorno
                returnTable: [
                    {
                        return: 'Fundo',
                    },
                    {
                        return: '',
                    }
                ],

                lastYearLabelsMonths: [
                ]

            };

            loadInfos(fund, dispatch)
        }

    }, []);

    return (
        <div className={classes.root}>
            <div className={classes.headerSearch}>

                <Typography variant="h6" align="left" style={{
                    display: 'flex',
                    alignItems: 'center'
                }}>
                    {location && location.state && location.state.fund ? location.state.fund.fund_name : ''}

                    {
                        fundScreen && fundScreen.cnpj && fundScreen['comdinheiro'] ?
                            <CheckCircleIcon style={{
                                marginLeft: '5px',
                                color: unoTheme.greenMoney,
                                fill: unoTheme.greenMoney
                            }} />

                            :

                            <>
                                {
                                    fundScreen ?
                                        <ReportProblemIcon style={{
                                            marginLeft: '5px',
                                            color: unoTheme.warningColor,
                                            fill: unoTheme.warningColor,
                                        }} /> : null
                                }

                            </>
                    }

                </Typography>

                <div style={{ display: 'flex', alignItems: 'center' }}>
                    {
                        referenceDate ?
                            <Typography variant={'body2'} style={{ marginRight: '8px' }}>
                                {"Data de referência: " + referenceDate}
                            </Typography> : null
                    }

                    {
                        referenceDate && fundScreen?.['comdinheiro'] ?
                            <UnoButton
                                style={{ marginRight: '16px' }}
                                size={'small'}
                                onClick={() => doReport()}
                                type='primary'
                                isIconButton
                                myIcon={<PrintIcon />}>
                            </UnoButton> : null
                    }

                    {

                        fundScreen
                            && fundScreen['dadosCadastrais']
                            && fundScreen['dadosCadastrais'].link_regulamento != undefined
                            && fundScreen['dadosCadastrais'].link_regulamento != "" ?

                            <UnoButton
                                style={{ marginRight: '16px' }}
                                size={'small'}
                                className={classes.spacingLeft1}
                                onClick={() => showRegulamento(fundScreen['dadosCadastrais'].link_regulamento)}
                                type='primary'
                                startIcon={<ImportContactsIcon />}>
                                {"Regulamento"}
                            </UnoButton> : null
                    }
                </div>

            </div>
            {
                fundScreen ?
                    <div className={classes.main}>
                        <div className={classes.generalInformations}>
                            <Grid container spacing={2}>
                                <Grid item lg={6} md={6} sm={12}>
                                    <Paper className={[classes.gridPaper, 'mainInfos'].join(' ')} elevation={1}>
                                        <Typography className={'title'}>
                                            {'Características'}
                                        </Typography>
                                        <br />

                                        <MyInfo
                                            outerlabel={'CNPJ:'}
                                            direction={'horizontal'}
                                            label={fundScreen.cnpj}>
                                        </MyInfo>
                                        <MyInfo outerlabel={'CNPJ Gestor:'}
                                            direction={'horizontal'}
                                            label={fundScreen.comdinheiro['dadosCadastrais'].manager_cnpj}>
                                        </MyInfo>
                                        <MyInfo outerlabel={'Gestão:'}
                                            direction={'horizontal'}
                                            label={fundScreen.comdinheiro['dadosCadastrais'].manager_name}>
                                        </MyInfo>
                                        <MyInfo outerlabel={'CNPJ Administrador:'}
                                            direction={'horizontal'}
                                            label={fundScreen.comdinheiro['dadosCadastrais'].administrator_cnpj}>
                                        </MyInfo>
                                        <MyInfo outerlabel={'Administrador:'}
                                            direction={'horizontal'}
                                            label={fundScreen.comdinheiro['dadosCadastrais'].administrator_name}>
                                        </MyInfo>
                                        <MyInfo outerlabel={'Taxa de Administração:'}
                                            direction={'horizontal'}
                                            label={fundScreen.comdinheiro['dadosCadastrais'].administration_tax + "%"}>
                                        </MyInfo>
                                        <MyInfo outerlabel={'Taxa de administração (Máxima):'}
                                            direction={'horizontal'}
                                            label={fundScreen.comdinheiro['dadosCadastrais'].max_administration_tax ?
                                                fundScreen.comdinheiro['dadosCadastrais'].max_administration_tax + "%" : "-"}>
                                        </MyInfo>
                                        <MyInfo outerlabel={'Benchmark:'}
                                            direction={'horizontal'}
                                            label={fundScreen.comdinheiro['realBenchmark'] ? fundScreen.comdinheiro['realBenchmark'] : "-"}>
                                        </MyInfo>
                                        {/* <MyInfo outerlabel={'Código de referência:'}
                                            direction={'horizontal'}
                                            label={fundScreen.comdinheiro.ref_cod}>
                                        </MyInfo> */}
                                        <MyInfo outerlabel={'Enquadramento:'}
                                            direction={'horizontal'}
                                            label={fundScreen.device_abbreviation}>
                                        </MyInfo>
                                    </Paper>

                                </Grid>
                                <Grid item lg={6} md={6} sm={12}>
                                    <Paper className={[classes.gridPaper, 'mainInfos'].join(' ')} elevation={1}>
                                        <Typography className={'title'}>
                                            {'Informações Operacionais'}
                                        </Typography>
                                        <br />

                                        <MyInfo outerlabel={'Início fundo:'}
                                            direction={'horizontal'}
                                            label={fundScreen.comdinheiro['dadosCadastrais'].fund_init}>
                                        </MyInfo>
                                        <MyInfo outerlabel={'Patrimônio líquido:'}
                                            direction={'horizontal'}
                                            label={applyMaskAmount(fundScreen.comdinheiro['dadosCadastrais'].pl_anbima, true)}>
                                        </MyInfo>
                                        <MyInfo outerlabel={'Núm. Cotistas:'}
                                            direction={'horizontal'}
                                            label={fundScreen.comdinheiro['dadosCadastrais'].num_cotistas ? fundScreen.comdinheiro['dadosCadastrais'].num_cotistas : "-"}>
                                        </MyInfo>
                                        <MyInfo outerlabel={'Aplicação mínima:'}
                                            direction={'horizontal'}
                                            label={fundScreen.comdinheiro['dadosCadastrais'].min_application ?
                                                'R$ ' + fundScreen.comdinheiro['dadosCadastrais'].min_application : '-'}>
                                        </MyInfo>
                                        <MyInfo outerlabel={'Aplicação adicional:'}
                                            direction={'horizontal'}
                                            label={applyMaskAmount(fundScreen.comdinheiro['dadosCadastrais'].aditional_application, true)}>
                                        </MyInfo>
                                        <MyInfo outerlabel={'Saldo mínimo:'}
                                            direction={'horizontal'}
                                            label={fundScreen.comdinheiro['dadosCadastrais'].min_balance ?
                                                'R$ ' + fundScreen.comdinheiro['dadosCadastrais'].min_balance : '-'}>
                                        </MyInfo>
                                        <MyInfo outerlabel={'Resgate Mínimo:'}
                                            direction={'horizontal'}
                                            label={fundScreen.comdinheiro['dadosCadastrais'].min_rescue ?
                                                'R$ ' + fundScreen.comdinheiro['dadosCadastrais'].min_rescue : '-'}>
                                        </MyInfo>
                                        <MyInfo outerlabel={'Conversão de cota para Aplicação:'}
                                            direction={'horizontal'}
                                            label={fundScreen.comdinheiro['dadosCadastrais'].conversion_application_quota}>
                                        </MyInfo>
                                        <MyInfo outerlabel={'Conversão de cota para Resgate:'}
                                            direction={'horizontal'}
                                            label={fundScreen.comdinheiro['dadosCadastrais'].conversion_rescue_quota}>
                                        </MyInfo>
                                        <MyInfo outerlabel={'Disponibilização dos Recursos Resgatados:'}
                                            direction={'horizontal'}
                                            label={fundScreen.comdinheiro['dadosCadastrais'].disponibilization}>
                                        </MyInfo>
                                    </Paper>
                                </Grid>

                                {
                                    fundScreen && fundScreen.description != null && fundScreen.description != "" ?
                                        <Grid item lg={12} md={12} sm={12}>

                                            <Paper className={[classes.gridPaper].join(' ')} elevation={1}>

                                                <Typography variant={'body1'} className={'title'} style={{ paddingBottom: '24px' }}>Resumo do fundo</Typography>

                                                <Typography variant={'body2'} style={{ textAlign: 'justify' }}>
                                                    {fundScreen.description}
                                                </Typography>

                                            </Paper>
                                        </Grid>
                                        : null
                                }


                                <Grid item lg={12} md={12} sm={12}>
                                    <Paper className={[classes.gridPaperTable].join(' ')} elevation={1}>

                                        <Typography variant={'body1'} className={'title'}>Tabela de retornos</Typography>

                                        <TableContainer>
                                            <Table className={classes.tableBlade} size={'small'}>
                                                <colgroup>
                                                    <col width="12%" />
                                                    {/* <col width="5%" /> */}
                                                    <col width="6%" />
                                                    <col width="6%" />
                                                    <col width="6%" />
                                                    <col width="5%" />
                                                    <col width="5%" />
                                                    <col width="5%" />
                                                    <col width="5%" />
                                                    <col width="5%" />
                                                    <col width="5%" />
                                                    <col width="5%" />
                                                    <col width="5%" />
                                                    <col width="5%" />
                                                    <col width="5%" />
                                                    <col width="5%" />
                                                    <col width="5%" />
                                                    <col width="5%" />
                                                </colgroup>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell align="left">Retorno(%)</TableCell>
                                                        {/* <TableCell align="center">Início</TableCell> */}
                                                        <TableCell align="center">Ano</TableCell>
                                                        <TableCell align="center">{'12'}<br />{'meses'}</TableCell>
                                                        <TableCell align="center">{'24'}<br />{'meses'}</TableCell>
                                                        <TableCell align="center">{'36'}<br />{'meses'}</TableCell>
                                                        {fundScreen.last12LabelsMonths.map((row, index) => (

                                                            <TableCell key={'h-return-table-' + index} align="center">{row}</TableCell>
                                                        ))}
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>

                                                    <TableRow key={'blade-fund-t1'}>

                                                        <TableCell align="left">{"Fundo"}</TableCell>
                                                        {/* <TableCell align="center">{applyMaskAmount(row.init)}</TableCell> */}

                                                        <TableCell align="center">{applyMaskAmountComdinheiro(fundScreen['comdinheiro'].returnTable.fund["Ano_atual"])}</TableCell>
                                                        <TableCell align="center">{applyMaskAmountComdinheiro(fundScreen['comdinheiro'].returnTable.fund["12_meses"])}</TableCell>
                                                        <TableCell align="center">{applyMaskAmountComdinheiro(fundScreen['comdinheiro'].returnTable.fund["24_meses"])}</TableCell>
                                                        <TableCell align="center">{applyMaskAmountComdinheiro(fundScreen['comdinheiro'].returnTable.fund["36_meses"])}</TableCell>

                                                        {fundScreen.last12LabelsMonths.map((labelMonth, index) => (

                                                            <TableCell align="center">
                                                                {
                                                                    applyMaskAmountComdinheiro(fundScreen['comdinheiro'].returnTable.fund[labelMonth])
                                                                }
                                                            </TableCell>

                                                        ))}

                                                    </TableRow>
                                                    <TableRow key={'blade-benchmark-t1'}>
                                                        <TableCell align="left">{fundScreen.comdinheiro['realBenchmark'] ? fundScreen.comdinheiro['realBenchmark'] : "-"}</TableCell>
                                                        {/* <TableCell align="center">{applyMaskAmount(row.init)}</TableCell> */}
                                                        <TableCell align="center">{applyMaskAmountComdinheiro(fundScreen['comdinheiro'].returnTable.benchmark["Ano_atual"])}</TableCell>
                                                        <TableCell align="center">{applyMaskAmountComdinheiro(fundScreen['comdinheiro'].returnTable.benchmark["12_meses"])}</TableCell>
                                                        <TableCell align="center">{applyMaskAmountComdinheiro(fundScreen['comdinheiro'].returnTable.benchmark["24_meses"])}</TableCell>
                                                        <TableCell align="center">{applyMaskAmountComdinheiro(fundScreen['comdinheiro'].returnTable.benchmark["36_meses"])}</TableCell>

                                                        {fundScreen.last12LabelsMonths.map((labelMonth, index) => (
                                                            <TableCell align="center">
                                                                {

                                                                    applyMaskAmountComdinheiro(fundScreen['comdinheiro'].returnTable.benchmark[labelMonth])


                                                                }
                                                            </TableCell>
                                                        ))}

                                                    </TableRow>

                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Paper>
                                </Grid>
                                <Grid item lg={12} md={12} sm={12}>

                                    <Paper className={[classes.gridPaperTable].join(' ')} elevation={1}>

                                        <Typography variant={'body1'} className={'title'}>Tabela de Risco x Retorno</Typography>

                                        <TableContainer>
                                            <Table className={classes.tableBlade} size={'small'}>
                                                <colgroup>
                                                    <col width="15%" />
                                                    <col width="9.44%" />
                                                    <col width="9.44%" />
                                                    <col width="9.44%" />
                                                    <col width="9.44%" />
                                                    <col width="9.44%" />
                                                    <col width="9.44%" />
                                                    <col width="9.44%" />
                                                    <col width="9.44%" />
                                                    <col width="9.44%" />
                                                    {/* <col width="8.1%" />
                                                    <col width="8.1%" /> */}
                                                </colgroup>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell align="left">Risco x Retorno (12m)</TableCell>
                                                        <TableCell align="center">Cota</TableCell>
                                                        <TableCell align="center">PL</TableCell>
                                                        <TableCell align="center">Volatilidade</TableCell>
                                                        <TableCell align="center">Perda máxima</TableCell>
                                                        <TableCell align="center">VaR</TableCell>
                                                        <TableCell align="center">Índice Sharpe</TableCell>
                                                        <TableCell align="center">Retorno Máximo</TableCell>
                                                        <TableCell align="center">Retorno Mínimo</TableCell>
                                                        <TableCell align="center">Retorno Médio</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    <TableRow key={'blade-fund-risco-retorno-fund'}>
                                                        <TableCell align="left">{"Fundo"}</TableCell>
                                                        <TableCell align="center">{applyMaskAmountComdinheiro(fundScreen['comdinheiro'].riscoRetorno.cota.fund)}</TableCell>
                                                        <TableCell align="center">{applyMaskAmountComdinheiro(fundScreen['comdinheiro'].riscoRetorno.pl.fund)}</TableCell>
                                                        <TableCell align="center">{applyMaskAmountComdinheiro(fundScreen['comdinheiro'].riscoRetorno.volatilidade.fund)}</TableCell>
                                                        <TableCell align="center">{applyMaskAmountComdinheiro(fundScreen['comdinheiro'].riscoRetorno.perda_maxima.fund)}</TableCell>
                                                        <TableCell align="center">{applyMaskAmountComdinheiro(fundScreen['comdinheiro'].riscoRetorno.var.fund)}</TableCell>
                                                        <TableCell align="center">{applyMaskAmountComdinheiro(fundScreen['comdinheiro'].riscoRetorno.indice_sharpe.fund)}</TableCell>
                                                        <TableCell align="center">{applyMaskAmountComdinheiro(fundScreen['comdinheiro'].riscoRetorno.retorno_maximo.fund)}</TableCell>
                                                        <TableCell align="center">{applyMaskAmountComdinheiro(fundScreen['comdinheiro'].riscoRetorno.retorno_minimo.fund)}</TableCell>
                                                        <TableCell align="center">{applyMaskAmountComdinheiro(fundScreen['comdinheiro'].riscoRetorno.retorno_medio.fund)}</TableCell>
                                                    </TableRow>
                                                    <TableRow key={'blade-fund-risco-retorno-benchmark'}>
                                                        <TableCell align="left">{fundScreen.comdinheiro['realBenchmark'] ? fundScreen.comdinheiro['realBenchmark'] : "-"}</TableCell>
                                                        <TableCell align="center">{applyMaskAmountComdinheiro(fundScreen['comdinheiro'].riscoRetorno.cota.benchmark)}</TableCell>
                                                        <TableCell align="center">{applyMaskAmountComdinheiro(fundScreen['comdinheiro'].riscoRetorno.pl.benchmark)}</TableCell>
                                                        <TableCell align="center">{applyMaskAmountComdinheiro(fundScreen['comdinheiro'].riscoRetorno.volatilidade.benchmark)}</TableCell>
                                                        <TableCell align="center">{applyMaskAmountComdinheiro(fundScreen['comdinheiro'].riscoRetorno.perda_maxima.benchmark)}</TableCell>
                                                        <TableCell align="center">{applyMaskAmountComdinheiro(fundScreen['comdinheiro'].riscoRetorno.var.benchmark)}</TableCell>
                                                        <TableCell align="center">{applyMaskAmountComdinheiro(fundScreen['comdinheiro'].riscoRetorno.indice_sharpe.benchmark)}</TableCell>
                                                        <TableCell align="center">{applyMaskAmountComdinheiro(fundScreen['comdinheiro'].riscoRetorno.retorno_maximo.benchmark)}</TableCell>
                                                        <TableCell align="center">{applyMaskAmountComdinheiro(fundScreen['comdinheiro'].riscoRetorno.retorno_minimo.benchmark)}</TableCell>
                                                        <TableCell align="center">{applyMaskAmountComdinheiro(fundScreen['comdinheiro'].riscoRetorno.retorno_medio.benchmark)}</TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Paper>
                                </Grid>
                                {
                                    dataRetornosChart ?

                                        <Grid item xs={12} lg={12} md={12} sm={12}>

                                            <Paper className={[classes.gridPaperTable].join(' ')} elevation={1}>

                                                <div className={classes.divChart}>
                                                    <div className={'chartHeader'}>

                                                        <Typography variant={'body1'} className={'title'}>Fundo x Benchmark</Typography>
                                                        <div className={'right'}>
                                                            <MySelect
                                                                style={{ marginRight: '8px' }}
                                                                value={typeChartSelected}
                                                                verysmall
                                                                onChange={(e) => handleChangeTypeChartPeriod(e.target.value)}
                                                                options={typesChart.map((row, index) => (

                                                                    <option key={'type-chart-' + index} value={index}>{row}</option>

                                                                ))}
                                                            />
                                                        </div>
                                                    </div>


                                                    <div className={'chartWrapper'}>
                                                        <Bar
                                                            data={dataRetornosChart}
                                                            options={optionsCompareChart}
                                                            plugins={[ChartDataLabels]}
                                                        />
                                                    </div>

                                                </div>
                                            </Paper>
                                        </Grid>

                                        : null
                                }

                                {
                                    dataPatrimonioChart ?

                                        <Grid item xs={12} lg={12} md={12} sm={12}>

                                            <Paper className={[classes.gridPaperTable].join(' ')} elevation={1}>

                                                <div className={classes.divChart}>
                                                    <div className={'chartHeader'}>

                                                        <Typography variant={'body1'} className={'title'}>Evolução do Patrimônio (Em Milhões)</Typography>
                                                        <div className={'right'}>
                                                            <MySelect
                                                                value={periodChartPatrimonioSelected}
                                                                verysmall
                                                                onChange={(e) => handleChangeChartPatrimonioPeriod(e.target.value)}
                                                                options={periods.map((row, index) => (

                                                                    <option key={'chart-period-' + index} value={index}>{row}</option>

                                                                ))}
                                                            />
                                                        </div>
                                                    </div>


                                                    <div className={'chartWrapper'}>
                                                        <Bar
                                                            data={dataPatrimonioChart}
                                                            options={optionsChartPatrimonio}
                                                            plugins={[ChartDataLabels]}
                                                        />
                                                    </div>

                                                </div>
                                            </Paper>
                                        </Grid>

                                        : null
                                }

                            </Grid>
                        </div>


                    </div>
                    : null
            }

        </div >
    );
}
